import React, { memo, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Modal , Typography, Button} from 'antd';
import Scrollbars from 'react-custom-scrollbars';

const { Title, Paragraph } = Typography;
const ContentShow = forwardRef((props,ref)=>{

    const [visible, setVisible] = useState(false);
    const [data,setData] = useState({});

    useEffect(()=>{
    },[]);

    const open = (data) =>{
        setData(data);
        setVisible(true);
    };

    const close = () => {
        setVisible(false);
    };

    useImperativeHandle(ref,()=>({
        open,
    }));

    return (
        <Modal
            title="查看内容"
            visible={visible}
            onCancel={()=>close()}
            bodyStyle={{
                paddingRight: "10px"
            }}
            destroyOnClose
            centered
            width={950}
            footer={<Button onClick={()=>close()}>关闭</Button>}
        >
            <Scrollbars  autoHeight autoHeightMax={"700px"}>
                <Title level={3}>{data?.title}</Title>
                <Paragraph style={{width: "max-content"}}>
                    <div
                        style={{ width: 899,padding: "0 10px" }}
                        dangerouslySetInnerHTML={{ __html: data?.cmSiteContent }} />
                </Paragraph>
            </Scrollbars>
        </Modal>
    )
})
export default memo(ContentShow);